export default __webpack_public_path__ + "static/puzzle-90cbf5d9c8556b3fbf2e4da68d694bb5.png";